import React from 'react';
import AppRoutes from './Route/AppRoutes';
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

function App() {
  return <AppRoutes />;
}

export default App;
